/**
 * Shared constants for parameter types and values
 * Used by both ParameterComponent and ParameterTypeComponent
 */

/**
 * Parameter Type Names - Maps operation types to display names
 * These represent the different comparison operations for parameters
 */
export const PARAM_TYPE_MAP: Record<string, string> = {
    "eq": "Uguale a",
    "min": "Minimo",
    "mineq": "Minimo (incluso)",
    "max": "Massimo",
    "maxeq": "Massimo (incluso)",
    "bool": "Sì/No",
    "range": "Intervallo",
    "rangeeq": "Intervallo (incluso)",
    "in": "Incluso in"
};
export const PARAM_TYPE_SYMBOLS_MAP: Record<string, string> = {
    "eq": "=",
    "min": ">",
    "mineq": ">=",
    "max": "<",
    "maxeq": "<=",
    "bool": "🔘", // Emoji per booleano/checkbox
    "range": "↔", // Simbolo per intervallo/range
    "rangeeq": "⇔", // Simbolo per intervallo incluso
    "in": "✅" // Emoji per "cerca in" / "trova in"
};
/**
 * Parameter Type Values - Maps value types to display names
 * These represent the data types that parameters can contain
 */
export const PARAM_TYPE_VALUE_MAP: Record<string, string> = {
    number: 'Numero',
    boolean: 'Sì/No',
    date: 'Data',
    range_number: 'Intervallo numerico',
    range_date: 'Intervallo di date',
    number_array: 'Lista di numeri',
    date_array: 'Lista di date'
};